export enum TextfieldType {
    TEXT = 'text',
    TEL = 'tel',
    NUMBER = 'number',
    EMAIL = 'email',
  }